'use client';

import {
  PopoverAnchor,
  PopoverContainer,
  PopoverRoot,
} from '@mentimeter/ragnar-ui/popover';
import {
  useClosePopoverPaywall,
  useActivePaywallPopover,
} from '../hooks/use-popover-paywall';

export function PaywallsPopover() {
  const { open, activePaywallPopoverContent, activePaywallPopoverRef } =
    useActivePaywallPopover();

  const closePaywallPopover = useClosePopoverPaywall();

  return (
    <PopoverRoot modal open={open}>
      <PopoverAnchor virtualRef={activePaywallPopoverRef} />
      <PopoverContainer
        width="auto"
        onInteractOutside={closePaywallPopover}
        onEscapeKeyDown={closePaywallPopover}
      >
        {activePaywallPopoverContent}
      </PopoverContainer>
    </PopoverRoot>
  );
}
